import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveFilterResourcesRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveFilterResourcesRequestSuccess() {
      return getState().request.isSuccessful;
    },
    isRetrieveFilterResourcesRequestFailure() {
      return getState().request.isFailure;
    },
    getFilterResources() {
      return getState().resources;
    },
    getFilterResourcesTotalPages() {
      return getState().totalPages;
    },
    getFilterResourcesFilter() {
      return getState().filter;
    },
    getFilterResourcesProjectUuid() {
      return getState().projectUuid;
    },
    areFilterResourcesDirty() {
      return getState().isDirty;
    },
  };
}

export { createSelector };
